import { render } from "./AssignTask.vue?vue&type=template&id=79f44b6a"
import script from "./AssignTask.vue?vue&type=script&lang=js"
export * from "./AssignTask.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__